module.exports = __webpack_public_path__ + "static/img/chance.f632ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/chance.png
// module id = qLh7
// module chunks = 2